import React from "react";
import { Close as CloseIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { DialogTitle, IconButton } from "@mui/material";

const CustomDialogTitle = ({ title, type = "default", onClose }) => {
    const theme = useTheme();
    const COLOR_LIST = {
        warning: theme.palette.warning.light,
        error: theme.palette.error.dark,
        success: theme.palette.success.light,
        info: theme.palette.info.light,
        default: "white",
    };
    return (
        <DialogTitle
            sx={{
                m: 0,
                p: 2,
                color: (theme) =>
                    type === "default" ? theme.palette.text.primary : "white",
                backgroundColor: COLOR_LIST[type],
            }}
        >
            {title}
            {onClose && (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) =>
                            type === "default"
                                ? theme.palette.error.main
                                : theme.palette.grey[50],
                    }}
                >
                    <CloseIcon />
                </IconButton>

            )}
        </DialogTitle>
    );
};

export default CustomDialogTitle;
